export default "__VITE_ASSET__6yPG5HfZ__"